export enum Capabilities {
    TRACKING_DEVICE_MANAGE = 'tracking_devices_manage',
    TRACKING_DEVICE_SHOW = 'tracking_devices_show',
    TRACKING_MANAGE = 'tracking_manage',
    TRACKING_SHOW = 'tracking_show',
}
